import Actions from '../../actions'
import store from '../../store'

let homeChangedModalOpen = false

export const getHomeChangedModalOpen = () => homeChangedModalOpen

export const setHomeChangedModalOpen = (value: boolean) => {
  homeChangedModalOpen = value
}

const homeSwitchChannel =
  typeof BroadcastChannel !== 'undefined'
    ? new BroadcastChannel('lmc-home-switch')
    : null

export const broadcastHomeSwitch = (data: {
  newHomeId: string
  newHomeName: string
}) => {
  homeSwitchChannel?.postMessage(data)
}

homeSwitchChannel?.addEventListener('message', (event) => {
  const { newHomeId, newHomeName } = event.data
  const state = store.getState() as any
  const currentHomeId = state.global.home?.id

  if (!currentHomeId || currentHomeId === newHomeId) return
  if (homeChangedModalOpen) return
  homeChangedModalOpen = true

  const action = Actions.openModal({
    modalId: 'homeChangedModal',
    data: {
      currentHomeName: newHomeName,
      requestedHomeId: currentHomeId
    }
  })
  // @ts-ignore untyped Redux store
  store.dispatch(action)
})
